import { useEffect, useState } from 'react';
import FERPA from '../../../../../components/FERPA/FerpaComponent';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useViewSessionsQuery } from '../../../../../features/authentication/classesApiSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMessagesQuestion } from '@fortawesome/pro-solid-svg-icons';
import { faBook, faClipboardList } from '@fortawesome/free-solid-svg-icons';
import TableSkeleton from '../../../../../components/SkeletonLoader/TableSkeleton';
import Skeleton from 'react-loading-skeleton';
import { SortUtils } from '../../../../../utils/sorting';
import { faCheck, faClose, faChartArea } from '@fortawesome/free-solid-svg-icons';
import { DateFormatter } from '../../../../../utils/DateFormatter';
import { Form } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const HeaderBar = () => {
  let { Id, studentId, courseId } = useParams();
  const [sortColumn, setSortColumn] = useState('date');
  const [sortDirection, setSortDirection] = useState('asc');
  const { data: sessionsData, isLoading } = useViewSessionsQuery({ classId: Id, courseId: courseId, studentId: studentId });
  const [reportData, setReportData] = useState([]);
  const [showAssignments, setShowAssignments] = useState(true);
  const [showAssessments, setShowAssessments] = useState(true);
  const renderSortIcons = (column) => {
    return (SortUtils.renderSortIcons(sortDirection, sortColumn, column));
  };

  useEffect(() => {
    setReportData(sessionsData?.studentSessions);
  }, [sessionsData]);

  const handleSort = async (column) => {
    let sortedData = [];
    var direction = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
    setSortColumn(column);
    setSortDirection(direction);
    sortedData = SortUtils.customSort(reportData, column, sortDirection === 'asc' ? true : false);
    setReportData(sortedData);
  };

  return (
    <div className="white-card">
      <div className="row align-items-center mb-3">
        <div className="col-md-6">
          <h2 className="primary-title mb-md-0">
            {isLoading && <Skeleton />}
            {!isLoading && <span className='fw-medium'>{`Sessions for ${sessionsData?.studentName}`}</span>}
          </h2>
        </div>
        <div className="col-md-6 d-flex gap-3 flex-column flex-sm-row  justify-content-between justify-content-md-end align-items-center">
          <div className="col-xl-1 text-xl-end ps-xl-0 mt-3 mt-xl-0 mr-2">
            <FERPA />
          </div>
          <button
            onClick={() => window.history.back()}
            className="btn btn-castleWhite btn-width">
            Back
          </button>
        </div>
      </div>

      <div style={{ border: '2px solid #E7EDFF', borderRadius: '10px', padding: '20px' }} className='d-flex flex-row justify-content-between my-4'>
        <span style={{ fontSize: '14px', fontWeight: '500' }}>{`Course: ${sessionsData?.courseName ?? ''}`}</span>
        <span style={{ fontSize: '14px', fontWeight: '500' }}>{`Class: ${sessionsData?.className ?? ''}`}</span>
      </div>

      <div className='d-flex flex-row mb-4 justify-content-between'>
        <div className='d-flex flex-row gap-3'>
          <div className='d-flex flex-row align-items-center'>
            <span className='me-2 assignmentIcon'>
              <FontAwesomeIcon icon={faBook} color='#FFFFFF' />
            </span>
            <span>Assignment</span>
          </div>
          <div className='d-flex align-items-center flex-row'>
            <span className='me-2 assessmentIcon'>
              <FontAwesomeIcon icon={faClipboardList} color='#FFFFFF' />
            </span>
            <span>Assessment</span>
          </div>
        </div>


        <div>
          <div className='d-flex flex-row gap-3 align-items-center'>
            <div>Display:</div>
            <Form.Check
              type="checkbox"
              id="showAssignments"
              className="d-flex flex-row align-items-center">
              <Form.Check.Input
                type="checkbox"
                defaultChecked={true}
                className='mr-1'
                onClick={(e) => setShowAssignments(!showAssignments)}
              />
              <Form.Check.Label>Assignments</Form.Check.Label>
            </Form.Check>


            <Form.Check
              type="checkbox"
              id="showAssessments"
              className="d-flex flex-row align-items-center">
              <Form.Check.Input
                type="checkbox"
                defaultChecked={true}
                className='mr-1'
                onClick={(e) => setShowAssessments(!showAssessments)}
              />
              <Form.Check.Label>Assessments</Form.Check.Label>
            </Form.Check>
          </div>
        </div>
      </div>

      <div className="custom-table table-responsive">
        {!isLoading &&
          <>
          <div className='mb-2'>This is a summary of the sessions and assignments for the student.  Click on a <b>Report</b> button to see the detailed report.</div>
            <table className='table reportTable w-100'>
              <thead className="thead-light align-middle">
                <tr>
                  <th scope="col" className='fw-medium cursor-pointer min-w-150' onClick={() => handleSort('date')}>
                    <span className='align-items-center d-flex justify-content-between'> <span>Date</span> {renderSortIcons('date')} </span>
                  </th>
                  <th scope="col" className='fw-medium cursor-pointer min-w-100' onClick={() => handleSort('description')}>
                    <span className='align-items-center d-flex justify-content-between'> <span> Description</span> {renderSortIcons('description')} </span>
                  </th>
                  <th scope="col" className='fw-medium cursor-pointer min-w-150' onClick={() => handleSort('teacher')}>
                    <span className='align-items-center d-flex justify-content-between'> <span>Teacher</span> {renderSortIcons('teacher')} </span>
                  </th>
                  <th scope="col" className='fw-medium cursor-pointer min-w-50' onClick={() => handleSort('questionsCount')}>
                    <span className='align-items-center d-flex justify-content-between'> <span>Questions</span> {renderSortIcons('questionsCount')} </span>
                  </th>
                  <th scope="col" className='fw-medium cursor-pointer min-w-50' onClick={() => handleSort('correctCount')}>
                    <span className='align-items-center d-flex justify-content-between'> <span><FontAwesomeIcon icon={faCheck} /></span> {renderSortIcons('correctCount')} </span>
                  </th>
                  <th scope="col" className='fw-medium cursor-pointer min-w-50' onClick={() => handleSort('incorrectCount')}>
                    <span className='align-items-center d-flex justify-content-between'> <span><FontAwesomeIcon icon={faClose} /></span> {renderSortIcons('incorrectCount')} </span>
                  </th>
                  <th scope="col" className='fw-medium cursor-pointer min-w-50' onClick={() => handleSort('correctOnRetryCount')}>
                    <span className='align-items-center d-flex justify-content-between'> <span><FontAwesomeIcon icon={faClose} /><FontAwesomeIcon icon={faCheck} /></span> {renderSortIcons('correctOnRetryCount')} </span>
                  </th>
                  <th scope="col" className='fw-medium cursor-pointer min-w-50' onClick={() => handleSort('crAnsweredCount')}>
                    <span className='align-items-center d-flex justify-content-between'> <span>CR Answered</span> {renderSortIcons('crAnsweredCount')} </span>
                  </th>
                  <th scope="col" className='fw-medium cursor-pointer min-w-75' onClick={() => handleSort('score')}>
                    <span className='align-items-center d-flex justify-content-between'> <span>Score</span> {renderSortIcons('score')} </span>
                  </th>
                  <th scope="col" className='fw-medium cursor-pointer min-w-150' onClick={() => handleSort('assignmentMode')}>
                    <span className='align-items-center d-flex justify-content-between'> <span>Assignment Mode</span> {renderSortIcons('assignmentMode')} </span>
                  </th>
                  <th scope="col" className="fw-medium min-w-100"></th>
                </tr>
              </thead>
              {!isLoading &&
                <>
                  {
                    <tbody>
                      {reportData?.map((item) => {
                        if (!showAssignments && !item.isAssessment) return;
                        if (!showAssessments && item.isAssessment) return;

                        var assignmentModeStyle = '';
                        var assignmentMode = item.assignmentMode?.toLowerCase().includes('quiz') ? 'Quiz' : item.assignmentMode;
                        switch (assignmentMode?.toLowerCase()) {
                          case 'open':
                            assignmentModeStyle = 'assignmentModeOpen';
                            break;
                          case 'review':
                            assignmentModeStyle = 'assignmentModeReview';
                            break;
                          case 'offline':
                            assignmentModeStyle = 'assignmentModeOffline';
                            break;
                          case 'lock':
                            assignmentModeStyle = 'assignmentModeLock';
                            break;
                          case 'quiz':
                            assignmentModeStyle = 'assignmentModeQuiz';
                            break;
                        }

                        var assignmentScore = item.score;
                        switch (item.score) {
                          case -1:
                            assignmentScore = 'Incomplete'
                            break;
                          case -2:
                            assignmentScore = 'Not Scored'
                            break;
                          case -3:
                            assignmentScore = 'Not Started'
                            break;
                        }

                        return (
                          <>
                            <tr key={`${item.sessionId}-key`}>
                              <td>{DateFormatter.toShortDate(item.date)}</td>
                              <td >
                                <div className='d-flex flex-row align-items-center gap-2' style={{maxWidth: '250px'}}>
                                  <div className={`${item.isAssessment ? 'assessmentIcon' : 'assignmentIcon'}  flex-shrink-0`}><FontAwesomeIcon icon={item.isAssessment ? faClipboardList : faBook} color='#FFFFFF' /></div>
                                  <div dangerouslySetInnerHTML={{ __html: item.description }}></div>
                                </div>

                              </td>
                              <td>{item.teacherName}</td>
                              <td style={{textAlign: 'center'}}>{item.questionsCount}</td>
                              <td style={{textAlign: 'center'}}>{item.correctCount}</td>
                              <td style={{textAlign: 'center'}}>{item.incorrectCount}</td>
                              <td style={{textAlign: 'center'}}>{item.correctOnRetryCount}</td>
                              <td style={{textAlign: 'center'}}>{item.crAnsweredCount}</td>
                              <td style={{textAlign: 'center'}}>{assignmentScore}</td>
                              <td>
                                <div className={`assignmentModeStyle ${assignmentModeStyle}`}>{assignmentMode}</div>
                              </td>
                              <td>
                                {item.assignmentId > 0 && <div className='d-flex flex-row gap-2'>
                                  <NavLink to={`/responses/${item.assignmentId}/${studentId}`}>
                                    <OverlayTrigger
                                      key="viewSessions"
                                      placement="top"
                                      overlay={<Tooltip className="custom-tooltip">Responses</Tooltip>}>
                                      <button
                                        id={'viewSessions' + item.id}
                                        className="btn grid-icon-btn action-btn-tile blue"
                                      >
                                        <FontAwesomeIcon icon={faMessagesQuestion} />
                                      </button>
                                    </OverlayTrigger>
                                  </NavLink>

                                  <NavLink to={`/assignments/${item.assignmentId}/manage_assign/reports/student_session_report?studentId=${studentId}`}>
                                    <OverlayTrigger
                                      key="viewSessions"
                                      placement="top"
                                      overlay={<Tooltip className="custom-tooltip">Student Session Report</Tooltip>}>
                                      <button
                                        id={'viewSessions' + item.id}
                                        className="btn grid-icon-btn action-btn-tile blue"
                                      >
                                        <FontAwesomeIcon icon={faChartArea} />
                                      </button>
                                    </OverlayTrigger>
                                  </NavLink>
                                </div>}
                              </td>
                            </tr>
                          </>
                        )
                      }

                      )}
                    </tbody>
                  }
                </>}
            </table>
          </>}
        {isLoading &&
          <>
            <table className='w-100'>
              <TableSkeleton
                colCount={8}
                rowCount={4} />
            </table>
          </>
        }
      </div>
    </div>
  );
};

HeaderBar.propTypes = {
  showCourseHelpIcon: PropTypes.bool
};
export default HeaderBar;